import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import DemoRequestModal from "./DemoRequestModal";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <>
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <h1 className="text-2xl font-bold text-gray-900">Zeelium</h1>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a href="#problem" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                Problem
              </a>
              <a href="#solution" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                Solution
              </a>
              <a href="#benefits" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                Benefits
              </a>
            </nav>

            {/* CTA Button */}
            <div className="hidden md:flex">
              <button 
                onClick={() => setIsDemoModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium transition-colors duration-200"
              >
                Request Demo
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                className="p-2 text-gray-600 hover:text-gray-900"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden border-t border-gray-100 py-4">
              <nav className="flex flex-col space-y-4">
                <a href="#problem" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                  Problem
                </a>
                <a href="#solution" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                  Solution
                </a>
                <a href="#benefits" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                  Benefits
                </a>
                <button 
                  onClick={() => {
                    setIsDemoModalOpen(true);
                    setIsMenuOpen(false);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium w-full"
                >
                  Request Demo
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Demo Request Modal */}
      <DemoRequestModal 
        isOpen={isDemoModalOpen} 
        onClose={() => setIsDemoModalOpen(false)} 
      />
    </>
  );
};

export default Header;